import React, { useState } from 'react';
import { TextField, Grid } from '@mui/material';
import { DataGrid } from '@mui/x-data-grid';
import { Button } from '@mui/material';
import PropTypes from 'prop-types';
import axios from 'axios';
import UpdateDataModal from './DataUpdateModal';

const DataTable = (props) => {
    const [searchText, setSearchText] = useState('');
    const [updatemodalopen, setUpdateModalOpen] = useState(false);
    const [initialData, setUpdateRow] = useState({});

    const handleSearch = (e) => {
        setSearchText(e.target.value);
    };

    const filteredData = props.data.filter((item) =>
        Object.values(item).some((value) =>
            value.toString().toLowerCase().includes(searchText.toLowerCase())
        )
    );

    const handleRowEdit = (rowData) => {
       
        setUpdateRow(rowData)
        setUpdateModalOpen(true)
   
    };

    const closeUpdateModal=()=>{
        setUpdateModalOpen(false)
    }

    const openUpdateModal=()=>{
        setUpdateModalOpen(true)
    }
    
    const handleRowDelete = (rowData) => {
      
        const entryId = rowData.id;
        let config = {
            method: 'delete',
            url: `/api/data-entry/${entryId}/`,
            headers: { 'Authorization': `Bearer ${props.accessToken}` }
        };
        axios.request(config)
            .then(() => {
                alert('Deleted successfully');
                props.fetchData()
                // Implement your success handling logic here
            })
            .catch(error => {
                console.error('Deletion failed:', error);
                // Implement your error handling logic here
            });
    };

    const columns = [
        { field: 'locationTrackingCode', headerName: 'Location Tracking Code', width: 180, editable: true },
        { field: 'uniqueBoxBarcode', headerName: 'Unique Box Barcode', width: 150, editable: true },
        { field: 'department', headerName: 'Department', width: 120, editable: true },
        { field: 'client', headerName: 'Client', width: 120, editable: true },
        { field: 'documentType', headerName: 'Document Type', width: 150, editable: true },
        { field: 'boxCode', headerName: 'Box Code', width: 120, editable: true },
        { field: 'boxSequenceStart', headerName: 'Box Sequence Start', width: 150, editable: true },
        { field: 'boxSequenceStop', headerName: 'Box Sequence Stop', width: 150, editable: true },
        { field: 'dateFrom', headerName: 'Date From', width: 120, editable: true },
        { field: 'dateTo', headerName: 'Date To', width: 120, editable: true },
        { field: 'handoverDate', headerName: 'Handover Date', width: 150, editable: true },
        {
            field: 'actions',
            headerName: 'Actions',
            width: 240,
            renderCell: (params) => (
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button className='mx-1' variant="contained" color="primary" size='small' onClick={() => handleRowEdit(params.row)}>Edit</Button>
                    <Button className='mx-1' variant="contained" color="error" size='small' onClick={() => handleRowDelete(params.row)}>Delete</Button>
                </div>
            ),
        },
        
    ];

    return (

       <>
        <UpdateDataModal isOpen={updatemodalopen} onClose={closeUpdateModal} initialData={initialData} fetchData={props.fetchData} accessToken={props.accessToken}/>
        <Grid container >
            <Grid item xs={12}>
                <div className='bg-white'>
                    <div className='input-group'>
                        <Button onClick={props.openModal} variant="contained" color="warning">ADD NEW ENTRY</Button>
                        <TextField
                            label="Search"
                            variant="outlined"
                            fullWidth
                            value={searchText}
                            onChange={handleSearch}
                            style={{ marginBottom: '20px', backgroundColor: '#ffff' }}
                            size='small'
                            className='my-3'
                        />
                    </div>
                    <div style={{ height: 400, width: '100%', overflow: 'scroll' }}>
                        <DataGrid
                            rows={filteredData}
                            columns={columns}
                            pageSize={5}
                            checkboxSelection
                            disableSelectionOnClick
                            autoHeight
                            size='small'
                        />
                    </div>
                </div>
            </Grid>
        </Grid>
       </>
    );
};

DataTable.propTypes = {
    data: PropTypes.array.isRequired,
    openModal: PropTypes.func.isRequired,
};

export default DataTable;
